import {AgentPreferences, defaultPrefs} from "../util/defaultPrefs.tsx";

export const defaultDriverPrefs: AgentPreferences = {
    ...defaultPrefs,
    inspectionTierColors: [
        {tier: "NOTHING", color: "primary", watched: true},
    ],
};

